// src/frontend/js/modern/shared/cart-helpers.js

/**
 * Shared cart-related helper functions used by wishlist and save-for-later modules.
 * These were previously duplicated in both modules' index.js files.
 */

import {ensurejQuery} from "./ui-helpers";

/**
 * Check if the add-to-cart AJAX request should be sent.
 * Fires the WooCommerce 'should_send_ajax_request.adding_to_cart' event
 * and allows third-party plugins to cancel the request.
 * @param {HTMLElement} button - The add-to-cart button element
 * @returns {boolean}
 */
export function shouldSendAddToCartRequest(button) {
	const jQuery = window.jQuery;
	if (!jQuery) return true;
	const result = jQuery(document.body).triggerHandler('should_send_ajax_request.adding_to_cart', [ensurejQuery(button)]);
	return result !== false;
}

/**
 * Trigger the WooCommerce 'adding_to_cart' event on document body.
 * @param {HTMLElement} button - The add-to-cart button element
 * @param {Object} data - Additional data to pass with the event
 */
export function triggerAddingToCart(button, data) {
	const jQuery = window.jQuery;
	if (jQuery) {
		jQuery(document.body).trigger('adding_to_cart', [ensurejQuery(button), data || {}]);
	}
}

/**
 * Trigger WooCommerce cart fragment refresh and added_to_cart events.
 * @param {Object} fragments - Cart fragments HTML
 * @param {string} cartHash - Cart hash string
 * @param {HTMLElement} button - The add-to-cart button element
 */
export function triggerAddedToCartEvents(fragments, cartHash, button) {
	const jQuery = window.jQuery;
	if (jQuery) {
		jQuery(document.body).trigger('wc_fragment_refresh');
		jQuery(document.body).trigger('added_to_cart', [fragments, cartHash, ensurejQuery(button)]);
	}
}

/**
 * Trigger the WooCommerce 'ajax_request_not_sent.adding_to_cart' event
 * when the add-to-cart request is blocked by a third-party filter.
 * @param {HTMLElement} button - The add-to-cart button element
 */
export function triggerAjaxRequestNotSent(button) {
	const jQuery = window.jQuery;
	if (jQuery) {
		jQuery(document.body).trigger('ajax_request_not_sent.adding_to_cart', [false, false, ensurejQuery(button)]);
	}
}
